import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import {
  AdminActions,
  AdminCompanyDetails,
  AdminFactorAssignmentAudit,
  AdminFactorAssignmentHistory,
  CreditLimitExceeded,
  CreditLimitExposure,
  CsrDashboard,
  FactorAssignment,
  InvoicePayDateChangeIndexReport,
  InvoicePayDateChangeShowReport,
} from './AdminActionsRouteComponents';

export const adminActionsRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: AdminActions,
    path: adminRoutes.adminActions,
  },
  {
    Component: AdminCompanyDetails,
    path: adminRoutes.companyDetails,
  },
  {
    Component: CsrDashboard,
    path: adminRoutes.csrDashboard,
  },
  {
    Component: CreditLimitExceeded,
    path: adminRoutes.creditLimitExceeded,
    permitOnly: [UserRoles.Underwriting, UserRoles.Treasury, UserRoles.Reviewer],
  },
  {
    Component: CreditLimitExposure,
    path: adminRoutes.creditLimitExposure,
    permitOnly: [UserRoles.Underwriting, UserRoles.Treasury, UserRoles.Reviewer],
  },
  {
    Component: InvoicePayDateChangeShowReport,
    path: `${adminRoutes.invoicePayDateChangeReport}/:payorId`,
    permitOnly: [UserRoles.Treasury, UserRoles.Underwriting],
  },
  {
    Component: InvoicePayDateChangeIndexReport,
    path: adminRoutes.invoicePayDateChangeReport,
    permitOnly: [UserRoles.Treasury, UserRoles.Underwriting],
  },
  {
    Component: FactorAssignment,
    path: adminRoutes.factorAssignment,
    permitOnly: [UserRoles.OpsManager, UserRoles.SeniorNoaProcessor],
  },
  {
    Component: AdminFactorAssignmentAudit,
    path: `${adminRoutes.factorAssignment}/audit`,
    permitOnly: [UserRoles.OpsManager],
  },
  {
    Component: AdminFactorAssignmentHistory,
    path: `${adminRoutes.factorAssignment}/history`,
    permitOnly: [UserRoles.OpsManager],
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
